import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormValidation from '@react-form-fields/material-ui/components/FormValidation';
import FieldText from '@react-form-fields/material-ui/components/Text';
import { FormComponent, IStateForm } from 'components/Abstract/Form';
import Snackbar from 'components/Shared/Snackbar';
import { WithStyles } from 'decorators/withStyles';
import { History } from 'history';
import React, { MouseEvent } from 'react';
import rxjsOperators from 'rxjs-operators';
import authService from 'services/auth';

interface IState
  extends IStateForm<{
    email: string;
    password: string;
  }> {
  opened: boolean;
  loading: boolean;
}

interface IProps {
  classes?: any;
  history: History;
  onRecoveryAccess: (e: MouseEvent<HTMLElement>) => void;
  onLoginSuccess: () => void;
}

@WithStyles((theme) => ({
  buttons: {
    flexDirection: 'column',
  },
  button: {
    minWidth: 150,
    marginBottom: 6,
  },
}))
class _LoginDialogForm extends FormComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { ...this.state, opened: false, loading: false };
  }

  onSubmit = async (isValid: boolean) => {
    const { model } = this.state;
    if (!isValid) return;

    this.setState({ loading: true });

    const next =() => {
      this.setState({ loading: false });
      this.resetForm();
      this.props.onLoginSuccess();
    };

    const error = (err: unknown) => {
      Snackbar.error(err);
      this.setState({ loading: false });
    };

    authService
      .checkEmailAndPass(model.email, model.password)
      .pipe(rxjsOperators.logError(), rxjsOperators.bindComponent(this))
      .subscribe( { next, error });
  };

  render() {
    const { model, loading } = this.state;
    const { classes, onRecoveryAccess } = this.props;

    return (
      <FormValidation onSubmit={this.onSubmit} ref={this.formValidationRef}>
        <Card elevation={0}>
          <CardContent>
            <FieldText
              label="Email"
              type="email"
              disabled={loading}
              value={model.email}
              validation="required|email"
              onChange={this.updateModel((model, v) => (model.email = v))}
              margin="dense"
            />

            <FieldText
              label="Senha"
              type="password"
              disabled={loading}
              value={model.password}
              validation="required"
              margin="dense"
              onChange={this.updateModel((model, v) => (model.password = v))}
            />
          </CardContent>

          <CardActions className={classes.buttons}>
            <Button
              className={classes.button}
              disabled={loading}
              variant="contained"
              color="primary"
              type="submit"
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                ' Entrar'
              )}
            </Button>
            <Button
              className={classes.button}
              disabled={loading}
              onClick={onRecoveryAccess}
            >
              Recuperar Acesso
            </Button>
          </CardActions>
        </Card>
      </FormValidation>
    );
  }
}

export default _LoginDialogForm;
